module.exports = __webpack_public_path__ + "img/172224.f854dcfc.png";